import { Component, OnInit } from '@angular/core';
import { Input } from '@angular/core';

@Component({
  selector: 'sc-icon-box',
  templateUrl: './icon-box.component.html',
  styleUrls: [
    './icon-box.component.css'
  ]
})

export class IconBoxComponent implements OnInit {

  @Input('label') public label: string;
  @Input('value') public value: string;
  @Input('label-color') public labelColor?: string;
  @Input('value-color') public valueColor?: string;
  @Input('icon-color') public iconColor?: string;
  @Input('background-left') public backgroundLeft?: string;
  @Input('background-right') public backgroundRight?: string;
  @Input('material-icon') public materialIcon?: string;
  @Input('box-padding') public boxPadding?: string;
  @Input('box-margin-bottom') public boxMarginBottom?: string;
  @Input('sub-value') public subValue?: string;
  @Input('display-sub-value-condition') public displaySubValueCondition?: string;

  constructor() {
  }

  public ngOnInit(): void {
  }

  public getValueColor() {
    return {
      color: this.valueColor || 'black'
    };
  }

  public getLabelColor() {
    return {
      color: this.labelColor || 'black'
    };
  }

  public getIconColor() {
    return {
      color: this.iconColor || 'black'
    };
  }

  public getBoxStyle() {
    return {
      'padding': this.boxPadding || '5px',
      'margin-bottom': this.boxMarginBottom || '20px',
      'background': 'linear-gradient(60deg, ' + this.backgroundLeft + ', ' + this.backgroundRight + ')'
    };
  }
}
